import { Component, Inject } from '@angular/core';
import {
    CookieService,
    IMenu,
    LocalStorageService,
    PERMISSOES_SERVICE_TOKEN,
    PermissoesService
} from '@sbt-suite/components';
import { environment } from 'src/environments/environment';
import { menuRoles } from './core/constants/roles';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    MODE = environment.MODE;
    URL_LOGIN = environment.URL_LOGIN;
    URL_LOGOUT = environment.URL_LOGOUT;

    menuItens: IMenu[] = [
        {
            label: 'Cadastros',
            roles: menuRoles.itensMenu.cadastro.roles,
            itens: [
                {
                    label: 'Campanha',
                    icone: 'star',
                    link: '/campanha',
                    roles: Object.values(menuRoles.itensMenu.cadastro.campanha).flat()
                },
                {
                    label: 'Comerciais',
                    icone: 'rocket',
                    link: '/comerciais',
                    roles: Object.values(menuRoles.itensMenu.cadastro.comerciais).flat()
                },
                {
                    label: 'Jurados',
                    icone: 'person_add',
                    link: '/jurados',
                    roles: Object.values(menuRoles.itensMenu.cadastro.jurado).flat()
                }
            ]
        },
        {
            label: 'Parâmetros',
            roles: menuRoles.itensMenu.parametros.roles,
            itens: [
                {
                    label: 'Categorias',
                    icone: 'verified_user',
                    link: '/categorias',
                    roles: Object.values(menuRoles.itensMenu.parametros.categoria).flat()
                },
                {
                    label: 'Anunciantes',
                    icone: 'group_work',
                    link: '/anunciantes',
                    roles: Object.values(menuRoles.itensMenu.parametros.anunciante).flat()
                }
            ]
        },
        {
            label: 'Relatórios',
            roles: menuRoles.itensMenu.relatorios.roles,
            itens: [
                {
                    label: 'Ranking Sistema Antigo',
                    icone: 'description',
                    link: '/rankingsistemaantigo',
                    roles: Object.values(menuRoles.itensMenu.relatorios.relatorio).flat()
                }
            ]
        }
    ];

    constructor(
        @Inject(PERMISSOES_SERVICE_TOKEN) private _permissoesService: PermissoesService,
        private _cookie: CookieService,
        private _localStorage: LocalStorageService
    ) {
        if (!environment.USE_BACKEND) {
            _localStorage.setItem('appToken', 'teste');
            _permissoesService.registrarPermissoes(['TESTE_VISUALIZAR']);
        }
        _permissoesService.initPermissoes();
    }

    async logout(event: boolean) {
        if (event) {
            try {
                this.clearCookie();
                this._localStorage.clear();
                window.open(this.URL_LOGOUT, '_self');
            } catch (error) {
                console.error(error);
            }
        }
    }

    private clearCookie() {
        let domain = '';
        if (this.MODE == 'dev' || this.MODE == 'prod') {
            domain = 'tvsbt.com.br';
        }
        this._cookie.delete('access_token', '/', domain);
        this._cookie.delete('refreshToken', '/', domain);
    }
}
